<div class="flex gap-2">
  <app-pan-button
    color="info"
    icon="edit"
    (click)="params.editCallback(params.data)"
    matTooltip="Edit Location Group"
    data-testid="bl-location-group-edit"
  ></app-pan-button>

  <a panButton color="primary" icon="arrow_forward" (click)="params.viewCallback(params.data)"> </a>
</div>
